import { normalizePanelSetting } from './helpers'

export default {

    setCardsHistory(state, history) {
      state.cardsHistory = history
    },
    setProjects(state, projects) {
      state.projects = projects
    },
    setData(state, data) {
      state.data = data
    },
    setType(state, type) {
      state.type = type
    },
    setKeyword(state, keyword) {
      state.keyword = keyword
    },
    setSearchMethod(state, type) {
      state.searchMethod = type
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading
    },
    setProject(state, project) {
      state.project = project
    },
    addMessage(state, message) {
      state.messages.push(message)
    },
    clearMessage(state) {
      if (state.messages.length >= 1) {
        state.messages.shift()
      }
    },
    setIdModal(state, id) {
      state.idModal = id
    },
    setIsModal(state, bool) {
      state.isModal = bool
    },
    setUser(state, user) {
      state.user = user
    },
    setEnv(state, env) {
      state.env = env
    },
    setPagination(state, pagination) {
      state.pagination = pagination
    },
    setSortMethod(state, method) {
      state.sortMethod = method
    },
    setHistoryMode(state, mode) {
      state.isHistoryMode = mode
      if (mode) {
        state.isApproveMode = false
        state.isDeployMode = false
      }
    },
    setHistoryData(state, data) {
      state.historyData = data
    },
    setHistoryPageData(state, data) {
      state.historyPageData = data
    },
    setDeployMode(state, mode) {
      state.isDeployMode = mode
      if (mode) {
        state.isApproveMode = false
        state.isHistoryMode = false
      }
    },
    setApproveMode(state, mode) {
      state.isApproveMode = mode
      if (mode) {
        state.isDeployMode = false
        state.isHistoryMode = false
      }
    },
    setUpdatedTickets(state, data) {
      state.updatedTickets = data
    },
    setUpdatedTicketsPage(state, data) {
      state.updatedTicketsPage = data
    },
    setTicketVersion(state, data) {
      state.ticketVersion = data
    },
    setIsConfirmApproveModalOpen(state, data) {
      state.isConfirmApproveModalOpen = data
    },
    // setApprovedCards(state, data) {
    //     state.approvedCards = data
    // },
    setDeployableVersions(state, data) {
      state.deployableVersions = data
    },
    setDeployableVersionsPage(state, data) {
      state.deployableVersionsPage = data
    },
    setIsConfirmDeployModalOpen(state, data) {
      state.isConfirmDeployModalOpen = data
    },
    setCurrentVersion(state, data) {
      state.currentVersion = data
    },
    setDevVersion(state, data) {
      state.devVersion = data
    },
    setQaVersion(state, data) {
      state.qaVersion = data
    },
    setNeedValidateKey(state, data) {
      state.needValidateKey = data
    },
    setPanelSetting(state, data) {
      state.panelSetting = normalizePanelSetting(data)
    },
    patchRecordInData(state, payload) {
      const index = state.data.findIndex((record) => record.key === payload.key)
      if (index === -1) return
      state.data.splice(index, 1, { ...state.data[index], ...payload })
    },
    patchTicketById(state, { id, ticket }) {
      const index = state.data.findIndex((record) => record._id === id)
      if (index === -1) return
      state.data.splice(index, 1, { ...state.data[index], ticket })
    },
    addRecordInData(state, record) {
      state.data = [record, ...state.data]
    },
    removeRecordByKey(state, key) {
      state.data = state.data.filter((record) => record.key !== key)
    },
  }
